import { ProgressBar } from './DomMenu';
import { EL } from './util/DomUtils';
import { PinboardObjectApi } from './PinboardObjectApi';
import { App } from './PinboardApp';
import { LocalDb } from './db/Database';
import { UiContext } from './util/UiContext';

import 'disposablestack/auto';
import { DomWindow } from './DomWindow';

import "@melloware/coloris/dist/coloris.css";
import Coloris from "@melloware/coloris";

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
/* This code is needed to properly load the images in the Leaflet CSS */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export var app : App;

async function bootApp() {
    const loading = EL('div', { idGetOrCreate: 'appLoading' });
    (window as any).pinboardHelpers = PinboardObjectApi.util;
    (window as any).pinboard = PinboardObjectApi;
    (window as any).log = (message: string, ...params: any) => PinboardObjectApi.app?.log(message, ...params);
    try {
        loading.innerText = 'Opening local database...';
        using pb = ProgressBar.show('initializing app');
        const localDb = await LocalDb.open();

        loading.innerText = 'Booting app...';
        UiContext.instance = app = new App(localDb);
        (window as any).pinboardApp = app;
        PinboardObjectApi.app = app;
        loading.innerText = 'Initializing app...';
        await app._initGlobal();
        switch (document.body.getAttribute('data-app-entry')) {
            case 'viewer':
                app._initAppViewer(); break;
            case 'default':
                app._initApp(); break;
            default:
                console.log("no data-app-entry specified, stopping app boot")
        }
        
        if (document.getElementById('appLoadingWrapper'))
            document.getElementById('appLoadingWrapper').style.display = 'none';

        if (!localStorage.offlineMode) app.remote.websocketConnect();

        let mru;
        if (location.search.length>1) {
            app.mainViewer.onNavigate(new URL(location.search.substring(1)), {previousUrl: null});
        } else if ((mru = app.readMru('documentMru')) && mru.length > 0) {
            app.mainViewer.onNavigate(new URL('memo:' + mru[0]), {previousUrl: null});
        } else if (localStorage.loginUser) {
            app.mainViewer.onNavigate(new URL('memo:' + localStorage.loginUser+"/welcome"), {previousUrl: null});
        } else {
            app.mainViewer.onNavigate(new URL('memo:' + "public/welcome"), {previousUrl: null});
        }
        await app.initUser(localStorage.loginUser);
        DomWindow.reopenTempWindows();
        Coloris.init();
        Coloris({el:"[data-colorpicker]"});
    } catch(err) {
        console.error(`App startup failed: ${err}`,err,err.__stack__);
        loading.innerText = `Application startup failed: ${err}`;
    }
}

bootApp();
